import React from 'react';
import { IIconProps, sizeMap } from './types';

export const EditIcon = ({ className, size = 'medium' }: IIconProps) => {
  return (
    <svg
      className={className}
      width={sizeMap[size].width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0183 3.96972L16.2594 1.7286C17.2332 0.754774 18.8121 0.754774 19.786 1.7286L22.2699 4.21253C23.2437 5.18636 23.2437 6.76524 22.2699 7.73906L20.0288 9.98019M20.0252 9.98747L7.01095 23.0017H1.00437L1.00049 16.9913L14.0148 3.977L20.0252 9.98747Z"
        stroke="currentcolor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
